var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2060DigitalLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 80,
    viewBox: "0 0 414 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.04 -2.13645e-06C131.41 -2.13645e-06 120.11 7.53 120.11 21.5V27.2C117.01 22.09 111.67 18.7 105.1 18.7C104.62 18.7 104.17 18.7 103.73 18.73L116.77 1.98L117.18 1.47H100.34L83.67 22.48C82.73 23.86 81.88 25.29 81.15 26.77V21.35C81.15 9.18 71.79 -2.13645e-06 59.37 -2.13645e-06C51.55 -2.13645e-06 43.38 4.07 39.6 11.78C37.35 5.05 30.41 -2.13645e-06 20.94 -2.13645e-06C8.22 -2.13645e-06 0 8.53 0 21.87H13.87C14.18 15.7 16.41 12.85 20.42 12.85C23.58 12.85 25.82 15.09 25.82 18.4C25.82 22.79 22.27 28.65 15.8 35.21C12.64 38.45 7.58 42.45 0.56 47V58.33H28.85L37.83 47H37.71L20.67 46.95C29.02 39.79 34.44 33.6 37.44 27.82V38.06C37.44 50.45 46.93 59.79 59.53 59.79C69.24 59.79 76.88 54.3 79.83 45.98C82.92 54.45 90.87 59.79 100.93 59.79C110.99 59.79 118.41 54.34 121.57 46.16C124.7 54.3 132.53 59.79 142.18 59.79C154.71 59.79 163.8 50.65 163.8 38.06V21.34C163.8 9.17 154.44 -0.0100021 142.02 -0.0100021L142.04 -2.13645e-06ZM65.42 39.33C65.42 42.83 64.36 47 59.3 47C55.47 47 53.18 44.13 53.18 39.33V20.54C53.18 15.81 55.53 12.87 59.3 12.87C64.36 12.87 65.42 17.04 65.42 20.54V39.33ZM100.48 47C95.93 47 92.77 43.38 92.77 39.06C92.77 34.74 96.16 31.5 100.48 31.5C105.03 31.5 108.49 34.89 108.49 39.29C108.49 43.69 105.02 47 100.48 47ZM148.08 39.33C148.08 42.83 147.02 47 141.96 47C138.13 47 135.84 44.13 135.84 39.33V20.54C135.84 15.81 138.19 12.87 141.96 12.87C147.02 12.87 148.08 17.04 148.08 20.54V39.33Z",
    fill: "url(#paint0_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.18 3.64C207.98 1.3 202.08 0 194.65 0H174.29V59.79H195.7C214.36 59.79 226 49.61 226 29.89C226 17.69 220.67 8.48 212.18 3.63V3.64ZM196.42 46.98H189.55V12.86H196.5C205.31 12.86 210.72 19.31 210.72 29.98C210.72 40.65 205.22 46.98 196.42 46.98Z",
    fill: "url(#paint1_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.82 0H230.41V10.2H243.82V0Z",
    fill: "url(#paint2_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.82 14.93H230.41V59.8H243.82V14.93Z",
    fill: "url(#paint3_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36 19.11H283.2C281.02 15.64 276.58 13.46 270.76 13.46C257.84 13.46 248.22 23.88 248.22 37.61C248.22 51.34 257.67 61.19 270.76 61.19C276.25 61.19 281.26 58.77 283.28 54.49V55.78C283.28 63.94 279.16 68.38 272.38 68.38C269.07 68.38 266.08 67.25 264.55 63.94H249.04C250.17 72.5 258.41 79.69 271.09 79.69C282.32 79.69 291.12 74.93 294.35 68.71C295.97 65.64 296.77 61.04 296.77 54.98V14.91H283.36V19.11ZM272.28 48.67C265.82 48.67 261.54 43.42 261.54 37.12C261.54 30.82 266.31 25.98 272.28 25.98C278.82 25.98 283.27 30.99 283.27 37.53C283.27 44.07 278.83 48.68 272.28 48.68V48.67Z",
    fill: "url(#paint4_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63 14.93H301.22V59.8H314.63V14.93Z",
    fill: "url(#paint5_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63 0H301.22V10.2H314.63V0Z",
    fill: "url(#paint6_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.12 0H325.71V14.93H319.09V25.13H325.71V59.79H339.12V25.13H345.59V14.93H339.12V0Z",
    fill: "url(#paint7_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37 19.71H382.21C379.63 15.59 374.54 13.41 369.05 13.41C356.21 13.41 346.6 24.07 346.6 37.32C346.6 50.57 355.81 61.31 369.05 61.31C374.95 61.31 380.28 58.89 382.21 54.93H382.37V59.79H395.78V14.95H382.37V19.72V19.71ZM371.15 48.79C364.93 48.79 360 43.7 360 37.48C360 31.26 364.85 25.93 370.98 25.93C377.11 25.93 382.37 31.02 382.37 37.32C382.37 43.62 377.44 48.79 371.14 48.79H371.15Z",
    fill: "url(#paint8_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.28 0V59.79H413.69V0H400.28ZM412.22 58.32H401.75C406.49 54.2 409.92 50.47 412.22 46.98V58.32Z",
    fill: "url(#paint9_linear_4_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.22 58.32H401.75C406.49 54.2 409.92 50.47 412.22 46.98V58.32Z",
    fill: "url(#paint10_linear_4_33)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_33",
    x1: 86.33,
    y1: -11.73,
    x2: 79.46,
    y2: 52.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_33",
    x1: 202.67,
    y1: -18.05,
    x2: 195.81,
    y2: 73.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_33",
    x1: 238.64,
    y1: -15.36,
    x2: 231.78,
    y2: 76.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_33",
    x1: 241.03,
    y1: -15.19,
    x2: 234.17,
    y2: 76.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_33",
    x1: 276.93,
    y1: -12.51,
    x2: 270.07,
    y2: 79.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_33",
    x1: 311.46,
    y1: -9.93,
    x2: 304.59,
    y2: 82.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_33",
    x1: 309.06,
    y1: -10.11,
    x2: 302.2,
    y2: 81.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_33",
    x1: 334.44,
    y1: -8.21,
    x2: 327.58,
    y2: 83.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_33",
    x1: 375.16,
    y1: -5.18,
    x2: 368.3,
    y2: 86.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_33",
    x1: 409.42,
    y1: -2.62,
    x2: 402.55,
    y2: 89.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_33",
    x1: 412.12,
    y1: 42.5,
    x2: 406.63,
    y2: 59.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B549"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 413.69,
    height: 79.68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2060DigitalLogoBlue);
export default __webpack_public_path__ + "static/media/2060Digital-logo-blue.7b1a9142852e54c4b5fd57ccaf08012c.svg";
export { ForwardRef as ReactComponent };